// extracted by mini-css-extract-plugin
module.exports = {"placeholderTile":"Placeholder_placeholderTile__23vsQ","container":"Placeholder_container__2eTSE"};